import React from "react";

import Hero from "../components/Hero";
import Shop from "./Shop";

export default function Home() {
  return (
    <div style={{ width: "100%", maxWidth: "100vw", overflowX: "hidden" }}>
      <Hero />
      <Shop />
      <section
        id="shop"
        style={{
          textAlign: "center",
          paddingTop: 60,
          paddingBottom: 120,
          paddingLeft: 20,
          paddingRight: 20,
          boxSizing: "border-box",
          width: "100%",
        }}
      >
        <div className="eyebrow">THE BEELUXE COLLECTION</div>
        <div className="section-title">Golden by Nature.</div>
        <p className="section-sub">
          A premium honey collection, crafted for those who expect more.
        </p>
      </section>
    </div>
  );
}
